import axios from 'axios'
import { getApiUrl } from '@/config/api'

const BASE = '/api/CatalogosView'

export default {
  /**
   * Carga varios catálogos en una sola petición.
   * @param {string[]} catalogos  Ej: ['almacen', 'ceco', 'umedida']
   * @returns {Object}  { almacen: [...], ceco: [...], umedida: [...] }
   */
  async leerVarios(catalogos) {
    const lista = Array.isArray(catalogos) ? catalogos.join(',') : catalogos
    const res = await axios.get(getApiUrl(`${BASE}/leer_catalogos/${lista}`))
    // Respuesta: [ { Catalogo: 'almacen', Items: [...] }, ... ]
    // Lo convertimos a un mapa por nombre
    const mapa = {}
    if (Array.isArray(res.data)) {
      res.data.forEach(entry => {
        mapa[entry.Catalogo] = entry.Items || []
      })
    }
    return mapa
  },

  /**
   * Busca en un catálogo por texto (clave o nombre).
   * Mínimo _MinLength caracteres para devolver resultados.
   * @param {string} catalogo  Nombre del catálogo (ej: 'material', 'socionegocio')
   * @param {string} texto     Texto a buscar
   * @param {number} minLength Mínimo de caracteres (default 3)
   */
  async buscar(catalogo, texto, minLength = 3) {
    const res = await axios.post(getApiUrl(`${BASE}/LeerCatalogoBuscarX`), {
      Clave:      catalogo,
      Nombre:     texto,
      _MinLength: minLength
    })
    return Array.isArray(res.data) ? res.data : []
  },

  // ─── Por usuario (v_catu_) ──────────────────────────────────────────────────

  async leerVariosU(catalogos) {
    const lista = Array.isArray(catalogos) ? catalogos.join(',') : catalogos
    const res = await axios.get(getApiUrl(`${BASE}/leer_catalogos_u/${lista}`))
    const mapa = {}
    if (Array.isArray(res.data))
      res.data.forEach(entry => { mapa[entry.Catalogo] = entry.Items || [] })
    return mapa
  },

  async buscarU(catalogo, texto, minLength = 0) {
    const res = await axios.post(getApiUrl(`${BASE}/LeerCatalogoBuscarU`), {
      Clave:      catalogo,
      Nombre:     texto,
      _MinLength: minLength
    })
    return Array.isArray(res.data) ? res.data : []
  }
}
